


































import { Component, Vue } from 'vue-property-decorator';
import MdViewer from '@/components/MdViewer.vue';

@Component({
    components: {
        MdViewer,
    },
    head: {
        title: {
            inner: 'Legal',
        },
    },
})
export default class Legal extends Vue {}

